var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "clickable ignore-popover",
      class: _vm.colorClass,
      staticStyle: { "user-select": "none" },
      on: {
        click: function ($event) {
          $event.preventDefault()
          return _vm.handleClick.apply(null, arguments)
        },
      },
    },
    [
      _c("i", {
        staticClass: "fa",
        class: _vm.bellClass,
        attrs: { "data-count": _vm.badgeCount, "aria-hidden": "true" },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }